// FileType labels (physical format from analysis_result.file_type)
export const FILE_TYPE_LABELS: Record<string, string> = {
  text_pdf: 'Text PDF',
  scanned_pdf: 'Scanned PDF',
  docx: 'DOCX',
  csv: 'CSV',
  excel: 'Excel',
  txt_plain: 'Plain Text',
  txt_structured: 'Structured Text',
  image: 'Image',
  unknown: 'Unknown',
}

// DocumentType labels (semantic content from analysis_result.document_type)
export const DOCUMENT_TYPE_LABELS: Record<string, string> = {
  invoice: 'Invoice',
  bank_statement: 'Bank Statement',
  receipt: 'Receipt',
  financial_record: 'Financial Record',
  contract: 'Contract',
  legal_document: 'Legal Document',
  id_card: 'ID Card',
  drivers_license: "Driver's License",
  passport: 'Passport',
  diploma: 'Diploma',
  insurance_card: 'Insurance Card',
  email: 'Email',
  correspondence: 'Correspondence',
  report: 'Report',
  blockchain_data: 'Blockchain Data',
  geospatial_data: 'Geospatial Data',
  log_file: 'Log File',
  generic: 'Generic',
  unknown: 'Unknown',
}

export function formatFileType(value: string | null | undefined): string {
  if (!value) return 'Unknown'
  return FILE_TYPE_LABELS[value] ?? value.replace(/_/g, ' ')
}

export function formatDocumentType(value: string | null | undefined): string {
  if (!value) return 'Unknown'
  return DOCUMENT_TYPE_LABELS[value] ?? value.replace(/_/g, ' ')
}
